import CheckinSuccess from '../../CheckinSuccess/CheckinSuccess';
import { FORM_LOAD_ERROR_INFO } from '../../PaymentEntryModal/lib/constants';

import InformationCard from './InformationCard';
import AmountSummaryCard from './AmountSummaryCard';
import { ReaderStatus, SAVE_CARD_STATUS_CONFIG } from './ReaderStatus';

const Information = ({
  paymentKind,
  cardMessage,
  amount,
  status,
  gratuity = 0,
  surchargeAmount = 0,
  costShare,
  showManualEntry = false,
  transactionId,
  token,
  saveCardOnly = false,
  formLoadError = null
}) => {
  if (saveCardOnly) {
    return (
      <ReaderStatus status={status} message={cardMessage} statusConfig={SAVE_CARD_STATUS_CONFIG} />
    );
  }

  if (paymentKind === 'saved-cards') {
    if (status === 'success') return <CheckinSuccess transactionId={transactionId} token={token} />;

    return (
      <div className="flex w-full flex-col items-center">
        <AmountSummaryCard
          amount={amount}
          gratuity={gratuity}
          surchargeAmount={surchargeAmount}
          costShare={costShare}
        />
        <div className="flex w-full flex-col items-center px-10 pt-2">
          <ReaderStatus status={status} message={cardMessage} showManualEntry={showManualEntry} />
        </div>
      </div>
    );
  }

  return (
    <InformationCard
      icon={formLoadError ? FORM_LOAD_ERROR_INFO.icon : 'illustration-credit-card'}
      iconSize={120}
      title={formLoadError ? FORM_LOAD_ERROR_INFO.heading : 'Enter your card details'}
      description={
        formLoadError
          ? formLoadError.message || FORM_LOAD_ERROR_INFO.description
          : 'You can also tap or insert your card on the reader.'
      }
      reserveDescriptionLines
    />
  );
};

export default Information;
